/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { GetOrganizationQueryResponse, GetOrganizationPathParams } from "../../types/organizationController/GetOrganization.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOrganization } from "../../client/organizationController/getOrganization.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOrganizationQueryKey = (orgId: GetOrganizationPathParams["orgId"]) => [{ url: '/api/organizations/:orgId', params: {orgId:orgId} }] as const

export type GetOrganizationQueryKey = ReturnType<typeof getOrganizationQueryKey>

export function getOrganizationQueryOptions(orgId: GetOrganizationPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getOrganizationQueryKey(orgId)
  return queryOptions<GetOrganizationQueryResponse, ResponseErrorConfig<Error>, GetOrganizationQueryResponse, typeof queryKey>({
   enabled: !!(orgId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return getOrganization(orgId, config)
   },
  })
}

/**
 * @summary Get organization details
 * {@link /api/organizations/:orgId}
 */
export function useGetOrganization<TData = GetOrganizationQueryResponse, TQueryData = GetOrganizationQueryResponse, TQueryKey extends QueryKey = GetOrganizationQueryKey>(orgId: GetOrganizationPathParams["orgId"], options: 
{
  query?: Partial<QueryObserverOptions<GetOrganizationQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getOrganizationQueryKey(orgId)

  const query = useQuery({
   ...getOrganizationQueryOptions(orgId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}